// src/redux/services/adminService/admin.Services.js
import { baseApi } from "../baseApi";

export const AdminApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // ================= ADMIN CRUD =================

        // CREATE ADMIN
        createAdmin: builder.mutation({
            query: (formData) => ({
                url: "/admin",
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["Admin"],
        }),

        // GET ALL ADMINS
        getAdmins: builder.query({
            query: ({ page = 1, limit = 10, search = "", status = "", role = "" } = {}) => {
                let url = `/admins?page=${page}&limit=${limit}`;
                if (search) url += `&search=${search}`;
                if (status) url += `&status=${status}`;
                if (role) url += `&role=${role}`;
                return url;
            },
            providesTags: ["Admin"],
        }),

        // GET ADMIN BY ID
        getAdminById: builder.query({
            query: (id) => `/admin/${id}`,
            providesTags: ["Admin"],
        }),

        // UPDATE ADMIN
        updateAdmin: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/admin/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Admin"],
        }),

        // CHANGE ADMIN STATUS
        changeAdminStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/admin-status/${id}`,
                method: "PATCH",
                body: { status },
            }),
            invalidatesTags: ["Admin"],
        }),

        // DELETE ADMIN
        deleteAdmin: builder.mutation({
            query: (id) => ({
                url: `/admin/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Admin"],
        }),

        // ================= PERMISSIONS =================

        // ✅ GET ADMIN PERMISSIONS
        getAdminPermissions: builder.query({
            query: (adminId) => ({
                url: `/admin-permissions/${adminId}`,
                method: "GET",
            }),
            providesTags: (result, error, adminId) => [
                { type: "AdminPermissions", id: adminId },
                "AdminPermissions",
            ],
        }),

        // ✅ UPDATE ADMIN PERMISSIONS
        updateAdminPermissions: builder.mutation({
            query: (data) => ({
                url: "/admin-permissions",
                method: "PUT",
                body: data,
            }),
            invalidatesTags: (result, error, { admin_id }) => [
                { type: "AdminPermissions", id: admin_id },
                "AdminPermissions",
                "Admin",
            ],
        }),

        // ✅ GET ALL PERMISSIONS (Template)
        getAllPermissions: builder.query({
            query: () => ({
                url: "/permissions",
                method: "GET",
            }),
            providesTags: ["Permissions"],
        }),

        // ✅ CREATE NEW PERMISSION (Admin only)
        createPermission: builder.mutation({
            query: (data) => ({
                url: "/permissions",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Permissions"],
        }),

        // ✅ DELETE PERMISSION (Admin only)
        deletePermission: builder.mutation({
            query: (id) => ({
                url: `/permissions/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Permissions"],
        }),
        getWaadUsers: builder.query({
            query: ({ waadId, type, search = "", page = 1, limit = 20 }) => {
                let url = `waad-users/${waadId}?type=${type}&page=${page}&limit=${limit}`;
                if (search) url += `&search=${search}`;
                return url;
            },
            providesTags: (result, error, { waadId }) => [
                { type: "WaadUsers", id: waadId },
            ],
        }),
       // src/redux/services/sabAdminService/admin.Services.js

    // UPDATE ADMIN
    updateAdmin: builder.mutation({
        query: (data) => ({
            url: "/update-admin",      // ✅ Backend route match
            method: "POST",            // ✅ Backend POST method use kar raha hai
            body: data,                // ✅ data में id, name, email, etc. sab kuch bhej rahe hain
        }),
        invalidatesTags: ["Admin"],
    }),
    }),
});

export const {
    // Admin CRUD
    useCreateAdminMutation,
    useGetAdminsQuery,
    useGetAdminByIdQuery,
    useUpdateAdminMutation,
    useChangeAdminStatusMutation,
    useDeleteAdminMutation,
    // Permissions
    useGetAdminPermissionsQuery,
    useUpdateAdminPermissionsMutation,
    useGetAllPermissionsQuery,
    useCreatePermissionMutation,
    useDeletePermissionMutation,
    useGetWaadUsersQuery,

} = AdminApi;